exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fm-notification {\n  position: absolute;\n  right: 1rem;\n  bottom: 0;\n  z-index: 9999;\n  width: 350px;\n  display: block;\n  transition: opacity 0.4s ease;\n  overflow: auto;\n}\n.fm-notification .fm-notification-item {\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid;\n  border-radius: 0.25rem;\n}\n.fm-notification .notify-enter-active {\n  transition: all 0.3s ease;\n}\n.fm-notification .notify-leave-active {\n  transition: all 0.8s ease;\n}\n.fm-notification .notify-enter, .fm-notification .notify-leave-to {\n  opacity: 0;\n}", ""]);

// exports
